module.exports = __webpack_public_path__ + "img/card_eg.67c65bac.jpg";